import styled from 'styled-components';
import * as S from '@/pages/search/mobile/components/filter/styles';
import { BottomSheet, getSiteConfig, useDetectMobile } from '@orcar/common-d2c';

type SingleInsuranceInfoProps = {
  title: string;
  subInfo: string;
};

const SingleInsuranceInfo = ({ title, subInfo }: SingleInsuranceInfoProps) => {
  const { insurance } = getSiteConfig();
  if (!insurance) return null;
  return (
    <SingleWrapper>
      <Item>
        <Text type='title'>{title}</Text>
        <Text type='sub'>{subInfo}</Text>
      </Item>
      {insurance.info.map((item, idx) => (
        <Item key={idx}>
          <Text type='sub'>
            {item.title +
              insurance.range.find((i) => i.insurance === title)?.range[idx]}
          </Text>
          <Text type='info'>{item.subs}</Text>
        </Item>
      ))}
    </SingleWrapper>
  );
};

type MobileInsuranceInfoModalProps = {
  onClose: () => void;
  keepScrollLocked?: boolean;
};

const MobileInsuranceInfoModal = ({
  onClose,
  keepScrollLocked,
}: MobileInsuranceInfoModalProps) => {
  const { screenHeight } = useDetectMobile();
  const { insurance } = getSiteConfig();
  if (!insurance) return null;
  return (
    <>
      <BottomSheet onClose={onClose} keepScrollLocked={keepScrollLocked}>
        <S.FilterTitlerWrapper header>
          <S.MobileFilterTitle header>자차 보험 안내</S.MobileFilterTitle>
        </S.FilterTitlerWrapper>
        <S.MobileScrollWrapper screenHeight={screenHeight}>
          {insurance.range.map((item, idx) => (
            <SingleInsuranceInfo
              key={idx}
              title={item.insurance}
              subInfo={item.info}
            />
          ))}
        </S.MobileScrollWrapper>
      </BottomSheet>
    </>
  );
};

export default MobileInsuranceInfoModal;

const SingleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 20px 0;
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_01};

  & > div {
    &:first-child {
      background-color: ${({ theme }) => theme.COLOR.PRIMARY_OPAQUE};
      border-bottom: 1px solid ${({ theme }) => theme.COLOR.GREY_01};
    }
    &:last-child {
      border: 0;
    }
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 20px;
  border-bottom: 1px dashed ${({ theme }) => theme.COLOR.GREY_01};
`;

const Text = styled.p<{ type: 'title' | 'sub' | 'info' }>`
  ${({ type, theme }) => {
    switch (type) {
      case 'title':
        return theme.FONT.B1;
      case 'sub':
        return theme.FONT.B2;
      case 'info':
        return theme.FONT.B3;
      default:
        return;
    }
  }}
  font-weight: ${({ type }) => type === 'title' && '600'};
`;
